import { CustomAttributeKeys } from '@src/constants';
import { Location, LocationAttribute } from '@src/lib/__generated/vetspire/sdk';

export const findCustomLocationAttribute = (attribute: CustomAttributeKeys, location: Location) => {
	const locationAttributes = location.attributes as LocationAttribute[];
	const attributeMatch =
		locationAttributes.find(({ customAttribute }) => customAttribute?.name === attribute) ?? null;

	return attributeMatch ? (attributeMatch.value as string) : null;
};
